// components
import { InnerHtml } from 'components/InnerHtml/inner-html';

interface AddressDetailProps {
  isAcc: boolean;
  isNord: boolean;
  zip: string;
  city: string;
  address: string;
}

export function AddressDetail({ isAcc, isNord, zip, city, address }: Readonly<AddressDetailProps>) {
  if (isAcc && isNord) {
    return null;
  }

  return (
    <>
      {address && <InnerHtml as="li" content={address} />}
      {zip && (
        <li>
          {zip && <InnerHtml as="span" content={zip} />}{' '}
          {city && <InnerHtml as="span" content={city} />}
        </li>
      )}
    </>
  );
}
